import {
    DndContext,
    closestCenter
  } from "@dnd-kit/core";
  import {
    SortableContext,
    useSortable,
    arrayMove,
    verticalListSortingStrategy
  } from "@dnd-kit/sortable";
  import { CSS } from "@dnd-kit/utilities";
  import { useState } from "react";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImage,
  faTrashCan
} from "@fortawesome/free-solid-svg-icons";
  
const SortableItem = ({ id, index, image,ppturl, onRemove }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div ref={setNodeRef} style={style} 
    className="saved-itemrow">
      <div className=""
      style={{ cursor: "grab", display: 'flex' }}
      {...attributes}
      {...listeners}
      >
        <p
        className="saved-countnumber"
      >
        {index + 1}.
      </p>

      <div className="saved-itembg">
        <img src={image} alt="" />
      </div>
      </div>
      {/* DRAG HANDLE */}
      

      <div className="savedtrashicon-div">
        <FontAwesomeIcon
          icon={faTrashCan}
          className="savedtrashicon"
          style={{ color: "#dc3545", fontSize: 20 }}
          onClick={() =>
          {
            onRemove(id)
            // console.log('test >>>', id)
          }
            
          }
        />
      </div>
    </div>
  );
};

  
  const SortableList = ({listarr, handleresp, removeLayout}) => {
    const [items, setItems] = useState([
        { id: "1", image: "https://www.theinkorporated.com/api/uploaded_files/3%20Columns_1.jpg" },
        { id: "2", image: "https://www.theinkorporated.com/api/uploaded_files/3%20Columns_2.jpg" },
        { id: "3", image: "https://www.theinkorporated.com/api/uploaded_files/3%20Columns_3.jpg" },
        { id: "4", image: "https://www.theinkorporated.com/api/uploaded_files/3%20Pointers%20Circular.jpg" },
        { id: "5", image: "https://www.theinkorporated.com/api/uploaded_files/3%20Pointers%20Semicircular.jpg" },
        { id: "6", image: "https://www.theinkorporated.com/api/uploaded_files/3%20Pointers_2.jpg" }
      ]);
    
      const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {
          // setItems((items) => {
          //   const oldIndex = items.findIndex(i => i.id === active.id);
          //   const newIndex = items.findIndex(i => i.id === over.id);
          //   return arrayMove(items, oldIndex, newIndex);
          // });
          handleresp((items) => {
            const oldIndex = items.findIndex(i => i.id === active.id);
            const newIndex = items.findIndex(i => i.id === over.id);
            return arrayMove(items, oldIndex, newIndex);
          })
        }
      };
    
      return (
        <DndContext
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={listarr.map(i => i?.id)}
            strategy={verticalListSortingStrategy}
          >
            <div className="saved-itemdiv">
              {listarr.map((item, index) => (
                <SortableItem
                  key={item.id}
                  id={item.id}
                  index={index}
                  image={item.imageurl}
                  ppturl={item.ppturl}
                  onRemove={removeLayout}
                />
              ))}
            </div>
          </SortableContext>
        </DndContext>
      );
  }

  export default SortableList;
  